import React from 'react';

interface AboutUsProps {}

const AboutUs: React.FC<AboutUsProps> = () => (
  <section className="w-full py-12 md:py-24 lg:py-32 bg-muted">
    <div className="container px-4 md:px-6">
      <div className="grid gap-10 lg:grid-cols-2 place-items-center">
        {/* Image Section */}
        <div className="flex justify-center">
          <img
            alt="Team collaboration during a project meeting"
            className="mx-auto max-w-sm md:max-w-md lg:max-w-full h-auto rounded-xl object-contain"
            src="/IMG_6298.jpeg"
          />
        </div>

        {/* Text Section */}
        <div className="space-y-4 text-center lg:text-left">
          <h2 className="text-3xl font-bold tracking-tighter md:text-4xl">
            About Us
          </h2>
          <p className="text-muted-foreground md:text-xl">
            FF Automaton started as a group of friends who shared a passion for developing ambitious projects. What began as a collaborative hobby soon evolved into a serious venture as we recognized the potential of our combined expertise in algorithmic trading.
          </p>
          <p className="text-muted-foreground md:text-xl">
            Our journey from enthusiastic developers to industry professionals has been driven by our commitment to innovation and excellence. Today, we're proud to offer cutting-edge algorithmic trading solutions that reflect both our technical prowess and our collaborative spirit.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUs;